export default __webpack_public_path__ + "static/media/BCPorter.32c227cf.webp";